module.exports = __webpack_public_path__ + "5d3a98d6fc2b43c52e116072801803c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/cardPay_inactive.png
// module id = 576
// module chunks = 0